import { atom } from 'recoil'
import { EstateModel } from '../selector/get-map-data-selector'

const map_side_bar_list_atom = atom<Array<EstateModel>>({
  key: 'map_side_bar_list_atom',
  default: [],
})

export default map_side_bar_list_atom
